import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CustomerInformation} from "./customer-information";
import {GetCustomerInformationService} from "./get-customer-information.service";
import {ClaimDto} from "../../../auto-generated-server-dtos/claim/claim-dto";
import {
  ClaimVerifiedCustomerInformationDto
} from "../../../auto-generated-server-dtos/customer-information/map/claim-verified-customer-information-dto";
import {debounceTime, Observable, Subject, switchMap} from "rxjs";
import {RepairDto} from "../../../auto-generated-server-dtos/claim/repairs/repair-dto";
import {SaveCustomerInformationService} from "./save-customer-information.service";
import {GetCountriesService} from "../../../services/get-countries.service";
import {GetStatesProvincesService, StateProvince} from "../../../services/get-states-provinces.service";
import {CustomerOnFileDto} from "../../../auto-generated-server-dtos/adjuster/claim/customer-on-file-dto";

@Component({
  selector: 'app-customer-information',
  templateUrl: './customer-information.component.html',
  styleUrls: ['./customer-information.component.css']
})
export class CustomerInformationComponent implements OnInit {

  @Input() applicationId = 0;
  @Input() customerOnFile: CustomerOnFileDto | undefined;
  @Input() isAdjusterView: boolean = false;
  @Input() isLocked!: boolean;
  @Output() customerRecordMatchEvent: EventEmitter<boolean> = new EventEmitter();

  claimVerifiedCustomerInformationDto: ClaimVerifiedCustomerInformationDto = {
    applicationId: 0,
    provinceStateId: 0,
    email: '',
    firstName: '',
    lastName: '',
    address: '',
    city: '',
    postalZipCode: '',
    phone: '',
    apt: '',
    countryId: 0,
  };
  customerInformationLoaded = false;
  private _saveCustomerInformation$: Subject<any>;
  public readonly saveCustomerInformation$: Observable<any>;
  saving = false;
  statesProvinces: StateProvince[] = this.getStateProvincesService.GetStatesProvinces(1);
  isMatch = false;

  constructor(
    private getCustomerInformationService: GetCustomerInformationService,
    private saveCustomerInformationService: SaveCustomerInformationService,
    private getStateProvincesService: GetStatesProvincesService,
  ) {
    this._saveCustomerInformation$ = new Subject();

    //This gives debounce saves with http cancellation
    this.saveCustomerInformation$ = this._saveCustomerInformation$.pipe(
      debounceTime(2000),
      switchMap((claimVerifiedCustomerInformationDto: ClaimVerifiedCustomerInformationDto): any => {
        return this.saveCustomerInformationService.saveCustomerInformation(claimVerifiedCustomerInformationDto);
      }));


    this.saveCustomerInformation$.subscribe(() => {
      this.saving = false;
    });

  }

  public saveCustomerInformationDebounce() {
    this.saving = true;
    this._saveCustomerInformation$.next(this.claimVerifiedCustomerInformationDto);
  }

  public saveCustomerInformation() {
    this.saving = true;
    this.saveCustomerInformationService.saveCustomerInformation(this.claimVerifiedCustomerInformationDto).subscribe(() => {
      this.saving = false;
    });
  }

  ngOnInit(): void {
    this.claimVerifiedCustomerInformationDto.applicationId = this.applicationId;
    this.getCustomerInformationService.getCustomerInformation(this.applicationId).subscribe(
      (claimVerifiedCustomerInformationDto: ClaimVerifiedCustomerInformationDto) => {
        this.customerInformationLoaded = true;
        if (!claimVerifiedCustomerInformationDto) {
          return;
        }
        this.claimVerifiedCustomerInformationDto = claimVerifiedCustomerInformationDto;
        this.compareCustomerInfo();
      });
  }

  protected formatPostalZipCode(postalZipCodeString: string | null | undefined) {
    if (postalZipCodeString) {
      postalZipCodeString = postalZipCodeString.replace(/\W/g,'').toUpperCase();
      if (postalZipCodeString.match(/^\d+$/) && postalZipCodeString.length === 9) {
          return `${postalZipCodeString.slice(0, 5)}-${postalZipCodeString.slice(5)}`
      } else if (postalZipCodeString.match(/^[A-Z]\d[A-Z]\d[A-Z]\d/)) {
        return `${postalZipCodeString.slice(0, 3)} ${postalZipCodeString.slice(3)}`
      }
      return postalZipCodeString;
    }
    return '';
  }

  protected formatPhoneNumber(phoneNumberString: string | null | undefined) {
    if (phoneNumberString) {
      const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
      }
      return phoneNumberString;
    }
    return '';
  }

  private compareCustomerInfo() {
    this.isMatch =
      this.customerOnFile?.firstName?.replace(/\s/g,'').toLowerCase() === this.claimVerifiedCustomerInformationDto.firstName?.replace(/\s/g,'').toLowerCase() &&
      this.customerOnFile?.lastName?.replace(/\s/g,'').toLowerCase() === this.claimVerifiedCustomerInformationDto.lastName?.replace(/\s/g,'').toLowerCase() &&
      this.customerOnFile?.postalZipCode?.replace(/\s/g,'').toLowerCase() === this.claimVerifiedCustomerInformationDto.postalZipCode?.replace(/\s/g,'').toLowerCase();
    
      this.customerRecordMatchEvent.emit(this.isMatch);
  }
  
}
